import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  TemplateRef,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { InfoTextService, MOBILE_BREAKPOINT } from '../../services/infotext.service';
import {
  InfotextDialogComponent,
  InfotextDialogData,
} from '../infotext-dialog/infotext-dialog.component';

@Component({
  selector: 'ui-infotext-trigger',
  standalone: true,
  imports: [MatIconModule],
  template: `
    <button
      type="button"
      class="inline-flex items-center justify-center bg-transparent border-0 cursor-pointer p-0 leading-none align-middle"
      (click)="trigger()"
    >
      <mat-icon
        class="!text-[20px] !w-[20px] !h-[20px] !leading-none"
        [svgIcon]="isActive() ? 'cp-info-filled' : 'cp-info'"
      ></mat-icon>
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfotextTriggerComponent {
  key = input.required<string>();
  text = input<string>();
  template = input<TemplateRef<unknown>>();
  alwaysModal = input<boolean>(false);

  private infotextService = inject(InfoTextService);
  private dialog = inject(MatDialog);
  private destroyRef = inject(DestroyRef);
  private insideDialog = !!inject(MatDialogRef, { optional: true });

  private activeKey = toSignal(this.infotextService.activeKey$, { initialValue: null });
  private dialogOpen = signal(false);

  protected isActive = computed(() =>
    this.infotextService.isMobile() ? this.dialogOpen() : this.activeKey() === this.key()
  );

  trigger(): void {
    const text = this.text();
    const template = this.template();
    if (!text && !template) return;

    if (window.innerWidth < MOBILE_BREAKPOINT || this.insideDialog || this.alwaysModal()) {
      this.dialogOpen.set(true);
      const ref = this.dialog.open(InfotextDialogComponent, {
        data: { text, template } satisfies InfotextDialogData,
        width: '90vw',
        maxWidth: '480px',
      });
      ref
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => this.dialogOpen.set(false));
    } else if (this.activeKey() === this.key()) {
      this.infotextService.showConceptual(null);
    } else {
      this.infotextService.showConceptual({ key: this.key(), text, template });
    }
  }
}
